export type LanguageCode = 'en' | 'ko' | 'vi';

export const DEFAULT_LANGUAGE: LanguageCode = 'ko';

export const LANGUAGE_STORAGE_KEY = 'smart-home-care-language';
